<mat-list>
  <mat-list-item *ngFor="let item of details | keyvalue; trackBy: trackByKey">
    <span mat-line>{{ item.value }}</span>
    <span mat-line>{{ toStartCase(item.key) }}</span>
  </mat-list-item>
</mat-list>
